
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import LegacyModal from '@/components/common/LegacyModal.vue';
import EditorViewModel from "@/components/content/EditorViewModel";

@Options({
    props: {},
    components: {
        Modal: LegacyModal,
    },
})
export default class ContentToolbar extends Vue {
    @Inject() vm!: EditorViewModel;

    save() {
        this.vm.content.save();
    }
}
